<button
  mat-icon-button
  routerLink="/cart"
  class="cart-icon-button"
  [matBadge]="cartCount"
  [matBadgeHidden]="cartCount <= 0"
  matBadgeColor="accent"
  matBadgeSize="small"
>
  <mat-icon>shopping_cart</mat-icon>
</button>
